<div class="adev-footer-container">
  <div class="adev-footer-columns">
    <div>
      <h2>社交媒體</h2>
      <ul>
        <li>
          <a [href]="ngLinks.MEDIUM" title="Angular 部落格">部落格</a>
        </li>
        <li>
          <a [href]="ngLinks.X" title="X (前 Twitter)">X (前 Twitter)</a>
        </li>
        <li>
          <a [href]="ngLinks.BLUESKY" title="Bluesky">Bluesky</a>
        </li>
        <li>
          <a [href]="ngLinks.YOUTUBE" title="YouTube">YouTube</a>
        </li>
        <li>
          <a
            [href]="ngLinks.DISCORD"
            title="加入 Angular 社群 Discord 伺服器的討論吧！"
          >
            Discord
          </a>
        </li>
        <li>
          <a [href]="ngLinks.GITHUB" title="GitHub">GitHub</a>
        </li>
        <li>
          <a
            [href]="ngLinks.STACKOVERFLOW"
            title="Stack Overflow：社群為你解答技術上的 Angular 問題。"
          >
            Stack Overflow
          </a>
        </li>
      </ul>
    </div>
    <div>
      <h2>社群</h2>
      <ul>
        <li>
          <a
            href="https://github.com/angular/angular/blob/main/CONTRIBUTING.md"
            title="向 Angular 做貢獻"
          >
            做貢獻
          </a>
        </li>
        <li>
          <a
            href="https://github.com/angular/code-of-conduct/blob/main/CODE_OF_CONDUCT.md"
            title="彼此尊重"
          >
            行為準則
          </a>
        </li>
        <li>
          <a
            href="https://github.com/angular/angular/issues"
            title="在 Github 上報告問題或提建議"
          >
            報告問題
          </a>
        </li>
        <li>
          <a
            href="https://devlibrary.withgoogle.com/products/angular?sort=updated"
            title="Google 的開發函式庫"
          >
            Google 的 開發函式庫
          </a>
        </li>
        <li>
          <a
            href="https://developers.google.com/community/experts/directory?specialization=angular"
            title="Angular Google 開發技術專家"
          >
            Angular Google 開發技術專家
          </a>
        </li>
      </ul>
    </div>
    <div>
      <h2>資源</h2>
      <ul>
        <li>
          <a routerLink="/press-kit" title="媒體聯絡、標誌和品牌形象。">宣傳資料</a>
        </li>
        <li>
          <a routerLink="/roadmap" title="路線圖">路線圖</a>
        </li>
      </ul>
    </div>
    <div>
      <h2>多語言</h2>
      <ul>
        <li>
          <a href="https://angular.dev/" title="English Version">English Version</a>
        </li>
        <li>
          <a href="https://dev.angular.tw/" title="正體中文版">正體中文版</a>
        </li>
        <li>
          <a href="https://angular.jp/" title="日本語版">日本語版</a>
        </li>
        <li>
          <a href="https://angular.kr/" title="한국어">한국어</a>
        </li>
      </ul>
    </div>
  </div>
  <p class="docs-license">
    由 Google 強力賦能 ©2010-2025。程式碼以<a routerLink="/license" title="協定文字">MIT-style 協定</a>授權。文件以
    <a href="https://creativecommons.org/licenses/by/4.0/">CC BY 4.0</a> 授權。
  </p>
</div>
